import { createAsyncThunk } from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import { OMS_BASE } from 'src/utils/constants';

// Warehouse Apis
export const getWarehouseListAsync = createAsyncThunk(
  'oms/getWarehouseListAsync',
  async function (
    params: {
      paramData: {
        page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string; isActive?: boolean; include?: string;
        warehouse_id: any
      }
    }, toolkit
  ) {
    return await AxiosClient('GET', `${OMS_BASE}/warehouse`, [], toolkit, params.paramData, toolkit.signal)
  }
)

export const createWarehouseDataAsync = createAsyncThunk(
  'oms/createWarehouseDataAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/warehouse`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const updateWarehouseDetailsAsync = createAsyncThunk(
  'oms/updateWarehouseDetailsAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/warehouse/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)

export const deleteWarehouseDataAsync = createAsyncThunk(
  'oms/deleteWarehouseDataAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/warehouse/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

export const getEditWarehouseListAsync = createAsyncThunk(
  'oms/getEditWarehouseListAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/warehouse/${payload?.id}?include=address,additional_data`
    return await AxiosClient('GET', url, [], toolkit, [])
  })

export const getCountriesAsync = createAsyncThunk(
  'oms/getCountriesAsync',
  async function (params: {}, toolkit) {
    return await AxiosClient('GET', `${OMS_BASE}/countries`, [], toolkit, [])
  }
)
export const getStateAsync = createAsyncThunk(
  'oms/getStateAsync',
  async function (params: { country_id: number }, toolkit) {
    return await AxiosClient('GET', `${OMS_BASE}/states?country_id=${params?.country_id}`, [], toolkit, [])
  }
)
export const getCityAsync = createAsyncThunk(
  'oms/getCityAsync',
  async function (params: { state_id: number }, toolkit) {
    return await AxiosClient('GET', `${OMS_BASE}/city?state_id=${params?.state_id}`, [], toolkit, [])
  }
)

//Inventory Adjustment APIs -----------------------------------------------------------------------------------------------------------------------------------------
export const getInventoryAdjustmentListAsync = createAsyncThunk(
  'oms/getInventoryAdjustmentListAsync',
  async function (
    params: {
      page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string;
      isActive?: boolean; include?: string; adjustment_id?: any; created_at_min?: string; created_at_max?: string; sync_status?: string
    },
    toolkit
  ) {
    const query = new URLSearchParams();
    // Required
    query.append("page", String(params.page));
    // Optional parameters only if provided
    if (params.limit) query.append("limit", String(params.limit));
    if (params.sort_by) query.append("sort_by", params.sort_by);
    if (params.sort_order) query.append("sort_order", params.sort_order);
    if (params.search) query.append("search", params.search);
    if (params.isActive !== undefined) query.append("isActive", String(params.isActive));
    if (params.include) query.append("include", params.include);
    if (params.created_at_min) query.append("created_at_min", params.created_at_min);
    if (params.created_at_max) query.append("created_at_max", params.created_at_max);
    if (params.sync_status) query.append("sync_status", params.sync_status);
    // Always included
    query.append("inventory_type", "inventory_adjustment");
    const url = `${OMS_BASE}/inventory-adjustment?${query.toString()}`;
    return await AxiosClient('GET', url, [], toolkit, [], toolkit.signal);
  }
);

export const getInventoryVariantsListAsync = createAsyncThunk(
  "oms/getInventoryVariantsListAsync",
  async function (
    params: {
      page: number; limit?: number; sort_by?: string; order_by?: string; source_warehouse_id?: string;
      destination_warehouse_id?: string; search?: string; type?: string;
    },
    toolkit
  ) {
    const query = new URLSearchParams();
    // Required
    query.append("page", String(params.page));
    if (params.limit) query.append("limit", String(params.limit));
    if (params.sort_by) query.append("sort_by", params.sort_by);
    if (params.order_by) query.append("order_by", params.order_by);
    if (params.search) query.append("search", params.search);
    if (params.source_warehouse_id)
      query.append("source_warehouse_id", String(params.source_warehouse_id));
    if (params.destination_warehouse_id)
      query.append("destination_warehouse_id", String(params.destination_warehouse_id));
    query.append("type", params.type ?? "inventory_adjustment");
    const url = `${OMS_BASE}/inventory-variants?${query.toString()}`;
    return await AxiosClient("GET", url, [], toolkit, [], toolkit.signal);
  }
);

export const createInventoryAdjustmentAsync = createAsyncThunk(
  'oms/createInventoryAdjustmentAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/inventory-adjustment`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)

export const updateInventoryAdjustmentAsync = createAsyncThunk(
  'oms/updateInventoryAdjustmentAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/inventory-adjustment/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)
export const adjustedInventoryAdjustmentAsync = createAsyncThunk(
  'oms/updateInventoryAdjustmentAsync',
  async function (payload: { payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/convert-to-adjustment`
    return await AxiosClient('POST', url, payload.payloadupdate, toolkit, [])
  }
)

export const editInventoryAdjustmentAsync = createAsyncThunk(
  'oms/editInventoryAdjustmentAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/inventory-adjustment/${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })

export const deleteItemInventoryAdjustmentAsync = createAsyncThunk(
  'oms/deleteItemInventoryAdjustmentAsync',
  async function (payload: { id: number; adjust_itemId }, toolkit) {
    const url = `${OMS_BASE}/inventory-adjustment/${payload?.id}/adjustment-item/${payload?.adjust_itemId}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// -----------------------------------------------------------------------------------------------------------------------------------
// Reason APIs
export const getReasonListAsync = createAsyncThunk(
  'oms/getReasonListAsync',
  async function (params: { paramData: { page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string; isActive?: boolean; include?: string; reason_id?: any } }, toolkit) {
    return await AxiosClient('GET', `${OMS_BASE}/inventory-reasons`, [], toolkit, params.paramData, toolkit.signal)
  }
)

export const getEditReasonListAsync = createAsyncThunk(
  'oms/getEditReasonListAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/inventory-reasons/${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })

export const createReasonDataAsync = createAsyncThunk(
  'oms/createReasonDataAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/inventory-reasons`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const updateReasonDetailsAsync = createAsyncThunk(
  'oms/updateReasonDetailsAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/inventory-reasons/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)
export const deleteReasonDataAsync = createAsyncThunk(
  'oms/deleteReasonDataAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/inventory-reasons/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)


// Inventory Transfer APIs ----------------------------------------------------------------------------------------------------------------------------------------
export const getInventoryTransferListAsync = createAsyncThunk(
  "oms/getInventoryTransferListAsync",
  async function (
    params: {
      page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string; isActive?: boolean;
      include?: string; created_at_min?: string; created_at_max?: string; sync_status?: string
    }, toolkit
  ) {
    const query = new URLSearchParams();
    // Required
    query.append("page", String(params.page));
    // Optional
    if (params.limit) query.append("limit", String(params.limit));
    if (params.sort_by) query.append("sort_by", params.sort_by);
    if (params.sort_order) query.append("sort_order", params.sort_order);
    if (params.search) query.append("search", params.search);
    if (params.isActive !== undefined) query.append("isActive", String(params.isActive));
    if (params.include) query.append("include", params.include);
    if (params.created_at_min) query.append("created_at_min", params.created_at_min);
    if (params.created_at_max) query.append("created_at_max", params.created_at_max);
    if (params.sync_status) query.append("sync_status", params.sync_status);
    query.append("inventory_type", "inventory_transfer");
    const url = `${OMS_BASE}/inventory-transfer?${query.toString()}`;
    return await AxiosClient("GET", url, [], toolkit, [], toolkit.signal);
  }
);

export const geteditInventoryTransferAsync = createAsyncThunk(
  'oms/geteditInventoryTransferAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/inventory-transfer/${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })
export const createInventoryTransferAsync = createAsyncThunk(
  'oms/createInventoryTransferAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/inventory-transfer`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const initiateTransferInventoryAsync = createAsyncThunk(
  'oms/initiateTransferInventoryAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/convert-to-transfer`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)

export const updateInventoryTransferAsync = createAsyncThunk(
  'oms/updateInventoryTransferAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/inventory-transfer/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)
export const deleteItemInventoryTransferAsync = createAsyncThunk(
  'oms/deleteItemInventoryTransferAsync',
  async function (payload: { id: number; transfer_itemId }, toolkit) {
    const url = `${OMS_BASE}/inventory-transfer/${payload?.id}/transfer-item/${payload?.transfer_itemId}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// ------------------------------------------------------------------------------------------------------------------------------------
// Custom Fields APIs
export const getCustomFieldsListAsync = createAsyncThunk(
  'oms/getCustomFieldsListAsync',
  async function (params: {
    paramData: {
      page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string;
      isActive?: boolean; include?: string; reason_id?: any; owner?: string
    }
  }, toolkit) {
    return await AxiosClient(
      'GET',
      `${OMS_BASE}/custom-fields`,
      [],
      toolkit,
      params.paramData,
      toolkit.signal,
      undefined,
      undefined,
      {emptyOn404: true}
    )
  }
)

export const getEditCustomFieldsListAsync = createAsyncThunk(
  'oms/getEditCustomFieldsListAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/custom-fields/${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })

export const createCustomFieldsAsync = createAsyncThunk(
  'oms/createCustomFieldsAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/custom-fields`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const updateCustomFieldsAsync = createAsyncThunk(
  'oms/updateCustomFieldsAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/custom-fields/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)
export const deleteCustomFieldsAsync = createAsyncThunk(
  'oms/deleteCustomFieldsAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/custom-fields/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)
// fields values options and values
export const createCustomFieldValuesAsync = createAsyncThunk(
  'oms/createCustomFieldValuesAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/custom-fields-value/custom-field/${payload.id}`
    return await AxiosClient('POST', url, payload?.payloadupdate, toolkit, [])
  }
)
export const getCustomFieldValueListAsync = createAsyncThunk(
  'oms/getCustomFieldValueListAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/custom-fields-value/custom-field/${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })

export const updateCustomFieldValuesAsync = createAsyncThunk(
  'oms/updateCustomFieldValuesAsync',
  async function (payload: { id: number; value_id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/custom-fields-value/custom-field/${payload?.id}/${payload?.value_id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)

export const deleteCustomFieldsValuesAsync = createAsyncThunk(
  'oms/deleteCustomFieldsValuesAsync',
  async function (payload: { id: number; value_id: number }, toolkit) {
    const url = `${OMS_BASE}/custom-fields-value/custom-field/${payload?.id}/${payload?.value_id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// ------------------------------------------------------------------------------------------------------------------------------------
// Generic Platform Field Data APIs (NATIVE)

const resolveNextUrl = (nextUrl: string): string => {
  const apiBase = process.env.REACT_APP_API_URL || ''
  if (nextUrl.startsWith(apiBase)) return nextUrl.slice(apiBase.length)
  try {
    const parsed = new URL(nextUrl)
    const path = parsed.pathname.replace(/^\/market_connect/, '')
    return `${path}${parsed.search}`
  } catch {
    return nextUrl
  }
}

export const getOmsPlatformFieldByOwnerAsync = createAsyncThunk(
  'oms/getOmsPlatformFieldByOwnerAsync',
  async function (params: { platformId: number; owner: string }, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/platform-fields/${params.platformId}`,
      [],
      toolkit,
      { field_type: 'NATIVE', includeLocalFields: false, owner: params.owner }
    )
  }
)

export const getOmsPlatformFieldDataOptionsAsync = createAsyncThunk(
  'oms/getOmsPlatformFieldDataOptionsAsync',
  async function (
    params: {
      fieldId?: number
      search_string?: string
      next_url?: string
      signal?: AbortSignal
    },
    toolkit
  ) {
    if (params.next_url) {
      return await AxiosClient('GET', resolveNextUrl(params.next_url), [], toolkit, {}, params.signal)
    }
    return await AxiosClient(
      'GET',
      `/api/platform-field-data/${params.fieldId}`,
      [],
      toolkit,
      { use_pagination: true, search_string: params.search_string ?? '' },
      params.signal
    )
  }
)